import { render, staticRenderFns } from "./ApartmentAddCustomerModal.vue?vue&type=template&id=a12591c4&"
import script from "./ApartmentAddCustomerModal.vue?vue&type=script&lang=ts&"
export * from "./ApartmentAddCustomerModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a12591c4')) {
      api.createRecord('a12591c4', component.options)
    } else {
      api.reload('a12591c4', component.options)
    }
    module.hot.accept("./ApartmentAddCustomerModal.vue?vue&type=template&id=a12591c4&", function () {
      api.rerender('a12591c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apartment/components/ApartmentAddCustomerModal.vue"
export default component.exports